import ko from 'knockout';
import _ from 'underscore';
// import koSchema from '@bingads-webui-component-legacy/ko-schema/index';

// const webpageCondition = window.globalLegacySchema.get('WebpageCondition');
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class ViewModel {
  constructor() {
    this.urls = ko.observable('');

    this.values = ko.computed(() => {
      const items = this.urls().split(/\r?\n/);

      return _.map(items, (item) => {
        return {
          Operand: 'Url',
          ArgumentOperand: item,
          Operator: 'Equals',
          DisplayOperator: i18n.get('DSA_AutoTargets_Specific_Target_Equals'),
          DisplayOperand: i18n.get('DSA_AutoTargets_Specific_Target_Operand_URL'),
        };

      });
    });

    this.reset = () => {
      this.urls('');
    };

    this.hasError = ko.observable(false);
  }
}
